































import {
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import WorkPreviewCollection from '@/components/ApplicationHR/WorkPreviewCollection.vue';
import ObjectFieldNormalizer from '@/classes/normalizers/field-normalizers/ObjectFieldNormalizer';
import LayoutMixin from '@/mixins/LayoutMixin';
import NormalizerMixin from '@/mixins/NormalizerMixin';
import { CrudOperation } from '@/types/CrudOperation';
import { Mutation, State } from 'vuex-class';

interface PimcoreObject {
  id: number;
  name: string;
  type: string;
}

interface ApplicationOption {
  typename: string;
  id: string;
  name: string;
}

interface SupplierWithV {
  quantity: string;
  supplier: PimcoreObject;
  size: string;
}

interface SupplierData {
  name: string[];
  size: number;
  recommend_quantity: number;
}

interface ApplicationWork {
  suppliers_with_v: SupplierWithV[];
  time_from: string;
  time_to: string;
  units: PimcoreObject;
  work_type: PimcoreObject;
}

interface PreviewWork {
  work_type: string;
  recommend_quantity: string | number;
  size: string | number;
  supplier: string;
  units: string | number;
}

interface ApplicationPreview {
  date_from: '';
  date_to: '';
  day_work: PreviewWork[];
  night_work: PreviewWork[];
}

@Component({
  components: {
    WorkPreviewCollection,
  },
})
export default class ApplicationHRPreview extends Mixins(LayoutMixin, NormalizerMixin) {
  previewData: ApplicationPreview = {
    day_work: [],
    night_work: [],
    date_from: '',
    date_to: '',
  }

  toCreateModal = false;

  newApplication: any = null;

  @Prop()
  formOptions!: Record<string, ApplicationOption[]>|null

  @Prop()
  formData!: Record<string, any>|null;

  @State('prevOperation', { namespace: 'entity' })
  prevOperation!: CrudOperation;

  @Mutation('setOperation', { namespace: 'entity' })
  setOperation!: (operation: CrudOperation) => void;

  async beforeMount() {
    try {
      this.newApplication = JSON.parse(String(localStorage.getItem('formData'))).newApplication;
    } catch (e) {
      console.error(e);
    }
    this.preparePreview();
  }

  normalizeObjectName(key: string, object: PimcoreObject): string {
    if (this.newApplication?.options && object) {
      const options = this.newApplication.options[key] || [];

      const item = options.find((option: any) => parseInt(option.id, 10) === object.id);
      return item
        ? item.name
        : object.name;
    }
    return this.normalizeValue(object);
  }

  prepareWork(workItems: Array<ApplicationWork|PreviewWork>): PreviewWork[] {
    return workItems.map((workItem) => {
      if ((workItem as PreviewWork).supplier) {
        return workItem as PreviewWork;
      }

      const { suppliers_with_v = [], work_type, units } = workItem as ApplicationWork;

      const supplierData = suppliers_with_v.reduce((accumulator: SupplierData, supplierWithV) => {
        const supplierName = this.normalizeObjectName('supplier', supplierWithV.supplier);
        accumulator.name.push(supplierName);
        accumulator.size += parseInt(supplierWithV.size, 10);
        accumulator.recommend_quantity += parseInt(supplierWithV.quantity, 10);
        return accumulator;
      }, {
        name: [],
        size: 0,
        recommend_quantity: 0,
      });
      return {
        work_type: this.normalizeObjectName('workType', work_type) || '-',
        recommend_quantity: supplierData.recommend_quantity ? supplierData.recommend_quantity.toString() : '-',
        size: supplierData.size ? supplierData.size.toString() : '-',
        supplier: supplierData.name.join(', ') || '-',
        units: this.normalizeObjectName('units', units) || '-',
      };
    });
  }

  preparePreview() {
    if (this.newApplication) {
      const {
        date_from, date_to, day_work, night_work,
      } = this.newApplication;
      const dayWork = day_work || day_work || [] as ApplicationWork[];
      const nightWork = night_work || night_work || [] as ApplicationWork[];
      this.previewData = {
        date_from,
        date_to,
        day_work: this.prepareWork(dayWork),
        night_work: this.prepareWork(nightWork),
      };
    } else if (this.formData) {
      const { date_from, date_to } = this.formData;
      const dayWork = this.formData.day_work?.items?.GeneralWork || [] as ApplicationWork[];
      const nightWork = this.formData.night_work?.items?.GeneralWork || [] as ApplicationWork[];
      this.previewData = {
        date_from,
        date_to,
        day_work: this.prepareWork(dayWork),
        night_work: this.prepareWork(nightWork),
      };
    }
  }

  backToEdit() {
    this.toCreateModal = true;
    this.setOperation(this.prevOperation);
  }
}
